import { Domain } from "../../api/partner/models/Domain";
import { DNSRecord } from "../../api/partner/models/DNSZone";
import { Editor } from "./Editor";
import { LoadingEditor } from "./LoadingEditor";
import { APIResponse } from "../../api/ModelFactory";

export const DnsEditor = function <TDeployment>(props: { domain?: Domain | null, records?: DNSRecord[] | null, readonlyMode: boolean, saveCall?: (domainId: string, added: DNSRecord[], updated: DNSRecord[], removed: DNSRecord[]) => Promise<APIResponse<TDeployment>>, onSave: (deployment: TDeployment) => void }) {
  if (props.domain && props.records) {
    return <Editor domain={props.domain} records={props.records} readonlyMode={props.readonlyMode} saveCall={props.saveCall} onSave={props.onSave} />
  }
  return <LoadingEditor />
}
